module.exports = __webpack_public_path__ + "img/holdTheIdentifyCard.8b626a61.png";